import React, { Component } from "react";
import LoadingWindow from '../../components/LoadingWindow';
import { create_Delete_Update_Information, getInformationWithData } from "../../services/CABE";
import { BsFileArrowUpFill, BsFileArrowDownFill, BsPercent } from "react-icons/bs";
import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import "../../css/general-style.css";
import "../../css/dashboard.css";
import { getIndexElement } from "../../functions/searchInObject";
import { pricesFormat } from "../../functions/pricesFormat";
import { confirmCloseAlert } from "../../functions/alerts";
import ExcelDocument from "../../components/ExcelDocument";
import { getDataSet } from "../../functions/generateDataSetExcel";
import { getValueCookie } from "../../services/cookieService";
import { getActualDateUTC, getDateFromReports } from "../../functions/dateFormat";
import { OrderArray } from "../../functions/generalFunctions";
import CustomerList from "../../components/CustomerList";
import { Menu } from "../../components/Menu/Menu";

export default class PromotionsView extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        FilterProductLines: [],
        ProductLines: [],
        order: true,
        Customer: {
            AddressLine1: '',
            City: '',
            CustomerName: '',
            CustomerNo: '',
            EmailAddress: '',
            PriceLevel: undefined,
            SalespersonNo: '',
            State: '',
            TelephoneNo: '',
            ZipCode: '',
            uniqueTrack: '',
        }
    }

    async getCustomerPromotions() {
        const data = {
            CustomerNo: this.state.Customer.CustomerNo,
            IdCompany: Number(getValueCookie('CompanyId'))
        }
        const result = await getInformationWithData('/Items/Promotions/Customer', data)
        if (result.status.code === 1) {
            await this.setState({ ProductLines: result.data, FilterProductLines: result.data })
            await this.refreshInputs()
        }
    }

    Contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    searchProductLines = async (e) => {
        const searchValue = e.target.value
        let Filter = []
        if (searchValue === '') {
            Filter = this.state.ProductLines
        } else {
            Filter = this.state.ProductLines.filter((detail) => {
                if (this.Contains(detail.ProductLineDesc, searchValue)) {
                    return detail
                } else {
                    return null
                }
            })
        }
        await this.setState({ FilterProductLines: Filter })
        await this.refreshInputs()
    }

    refreshInputs() {
        for (const item of this.state.FilterProductLines) {
            if (document.getElementById('priceMarginProdLine2_' + item.ProductLine)) {
                document.getElementById('priceMarginProdLine2_' + item.ProductLine).value = item.Discount
            }
        }
    }

    EnableMarginPrice(id) {
        if (document.getElementById(id)) {
            document.getElementById(id).removeAttribute('disabled')
        }
    }

    changePriceMargin = async (e) => {
        if (e.key === 'Enter') {
            const id = e.target.id.split('_')
            if (id.length === 2) {
                const temporal = this.state.ProductLines
                const temporal2 = this.state.FilterProductLines
                const index = getIndexElement(temporal, 'ProductLine', id[1])
                const index2 = getIndexElement(temporal2, 'ProductLine', id[1])
                if (index !== -1) {
                    const data = {
                        CustomerNo: temporal[index].CustomerNo,
                        Discount: Number(e.target.value),
                        ProductLine: temporal[index].ProductLine,
                        IdCompany: Number(temporal[index].IdCompany),
                        Username: getValueCookie('userName'),
                        Date: getActualDateUTC()
                    }
                    const result = await create_Delete_Update_Information('/Items/Promotions/Customer/Set', data)
                    if (result.status.code === 1) {
                        temporal[index].Discount = pricesFormat(e.target.value)
                        temporal2[index2].Discount = pricesFormat(e.target.value)
                        this.setState({ FilterProductLines: temporal2, ProductLines: temporal })
                        document.getElementById(e.target.id).setAttribute('disabled', 'disabled')
                        confirmCloseAlert('correct', 'The Discount of : ' + temporal[index].ProductLineDesc + ' for the Customer: ' + this.state.Customer.CustomerName + ' has changed successfully!')
                    } else {
                        confirmCloseAlert('incorrect', 'Whoops, something is wrong. Try again!')
                    }
                }
            }
        }
    }

    async GeneralOrder(key, asc, name) {
        const temporal = this.state[name]
        const Order = OrderArray(temporal, key, asc)
        await this.setState({ [name]: Order, order: !asc })
        await this.refreshInputs()
    }

    render() {
        const hasCustomer = !!this.state.Customer.CustomerNo;
        const hasData = this.state.ProductLines.length > 0;

        return (
            <div className="dash-page" style={{ paddingTop: '70px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsPercent style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Discounts Per Customer</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasCustomer ? `${this.state.Customer.CustomerName} · ${this.state.Customer.CustomerNo}` : 'Select a customer to view and edit their product line discounts'}
                        </p>
                    </div>
                    {hasData ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                {this.state.FilterProductLines.length} product lines
                            </span>
                        </div>
                    ) : null}
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Two-column layout when customer has data */}
                    <div style={{ display: 'flex', gap: '1.25rem', alignItems: 'flex-start' }}>

                        {/* LEFT — Customer panel (always visible) */}
                        <div style={{ width: '260px', flexShrink: 0, position: 'sticky', top: '80px' }}>
                            <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden' }}>
                                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.875rem 1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <AiOutlineUser style={{ color: 'rgba(255,255,255,0.7)' }} />
                                    <span style={{ color: 'white', fontWeight: 700, fontSize: '0.875rem' }}>
                                        {hasCustomer ? 'Customer' : 'Select Customer'}
                                    </span>
                                </div>
                                <div style={{ padding: '1rem 1.25rem' }}>
                                    <div style={{ marginBottom: '0.875rem' }}>
                                        <CustomerList headerName='Customer' nombrePadre="Promotions" Padre={this} />
                                    </div>

                                    {hasCustomer ? (
                                        <>
                                            <div style={{ borderTop: '1px solid #F1F5F9', paddingTop: '0.875rem', marginTop: '0.5rem' }}>
                                                <div style={{ fontWeight: 800, color: '#0F172A', fontSize: '0.9375rem', marginBottom: '4px' }}>
                                                    {this.state.Customer.CustomerName}
                                                </div>
                                                <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '5px', padding: '1px 7px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                    {this.state.Customer.CustomerNo}
                                                </span>
                                            </div>
                                            <div style={{ marginTop: '0.875rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                                {[
                                                    { l: 'Address', v: this.state.Customer.AddressLine1 },
                                                    { l: 'City', v: this.state.Customer.City },
                                                    { l: 'State', v: this.state.Customer.State },
                                                    { l: 'Zip Code', v: this.state.Customer.ZipCode },
                                                    { l: 'Phone', v: this.state.Customer.TelephoneNo },
                                                    { l: 'Email', v: this.state.Customer.EmailAddress },
                                                ].map((f, i) => f.v ? (
                                                    <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                                                        <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{f.l}</span>
                                                        <span style={{ fontWeight: 600, color: '#334155', fontSize: '0.8rem' }}>{f.v}</span>
                                                    </div>
                                                ) : null)}
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ textAlign: 'center', padding: '1rem 0', color: '#94A3B8', fontSize: '0.8rem' }}>
                                            No customer selected
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT — Discounts table */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                            {!hasData ? (
                                <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                                    <BsPercent style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                                    <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>
                                        {hasCustomer ? 'No discounts found for this customer.' : 'Select a customer from the left panel to view their discounts.'}
                                    </p>
                                </div>
                            ) : (
                                <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                                    <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem' }}>
                                        <div style={{ position: 'relative', flex: 1, maxWidth: '360px' }}>
                                            <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                            <input onChange={this.searchProductLines} placeholder='Search product line...' id='SearchPrmotions' type="text"
                                                style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }} />
                                        </div>
                                        <ExcelDocument
                                            id={"ExcelDiscountsByCustomers"}
                                            data={getDataSet(this.state.ProductLines, ['Product Line', 'Discount %'], ['ProductLineDesc', 'Discount'])}
                                            sheetname={"Discounts By Product Lines"}
                                            archname={"Discounts " + this.state.Customer.CustomerName + " " + getValueCookie('Company') + " " + getDateFromReports()}
                                        />
                                    </div>
                                    <div className="tableFixHeadSmall">
                                        <table className='table table-clean mb-0'>
                                            <thead>
                                                <tr>
                                                    <th onClick={() => this.GeneralOrder('ProductLineDesc', this.state.order, 'FilterProductLines')} style={{ cursor: 'pointer' }}>
                                                        Product Line
                                                        <span style={{ marginLeft: '4px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
                                                    </th>
                                                    <th className="text-center" onClick={() => this.GeneralOrder('Discount', this.state.order, 'FilterProductLines')} style={{ cursor: 'pointer', width: '200px' }}>
                                                        Discount %
                                                        <span style={{ marginLeft: '4px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.FilterProductLines.map((item, i) => (
                                                    <tr key={i} hidden={item.Visible === 0}>
                                                        <td style={{ fontWeight: 600, color: '#334155', fontSize: '0.875rem' }}>{item.ProductLineDesc}</td>
                                                        <td className="text-center">
                                                            <div onDoubleClick={() => this.EnableMarginPrice('priceMarginProdLine2_' + item.ProductLine)}
                                                                style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', cursor: 'text' }}
                                                                title="Double-click to edit">
                                                                <input
                                                                    disabled
                                                                    type="number"
                                                                    id={'priceMarginProdLine2_' + item.ProductLine}
                                                                    min={0}
                                                                    step={0.01}
                                                                    defaultValue={item.Discount}
                                                                    onKeyDown={this.changePriceMargin}
                                                                    style={{ width: '80px', textAlign: 'center', border: '1.5px solid #E2E8F0', borderRadius: '6px', padding: '4px 8px', fontSize: '0.875rem', fontWeight: 700, color: item.Discount > 0 ? '#059669' : '#94A3B8' }}
                                                                />
                                                                <span style={{ color: '#64748B', fontSize: '0.8rem', fontWeight: 600 }}>%</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="tfoot">
                                                <tr>
                                                    <td colSpan={2} style={{ color: '#94A3B8', fontSize: '0.78rem' }}>
                                                        Double-click a discount value to edit · Press Enter to save
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
